$.houdiniforms = {messages : {}};

$.extend( $.houdiniforms.messages, {
	steps_cancel: "Cancelar",
	steps_current: "Paso actual:",
	steps_pagination: "Paginación",
	steps_finish: "Finalizar",
	steps_next: "Siguiente",
	steps_previous: "Anterior",
	steps_loading: "Cargando ..."
} );